<template>
  <div>
    <NormalOrDialog
      :dialogOpen="filterDialogOpen"
      @openDialog="filterDialogOpen = true"
      @closeDialog="filterDialogOpen = false"
      dialogTitle="Lọc dữ liệu"
      :hideDialogFooter="true"
    >
      <template :slot="!$vuetify.breakpoint.mobile ? 'default' : 'dialog'">
        <ContentFilterItems
          @filterChanged="onFilterChanged"
          :semester_configs="(markSheetData || {}).semester_configs || []"
          :defaultFilter="this.filterPayload"
        ></ContentFilterItems>
      </template>
    </NormalOrDialog>
    <v-data-table
      id="content-table"
      v-if="markSheetData"
      :dense="true"
      item-key="id"
      disableSort
      :headers="headers"
      :items="tableData"
      item-class="row-class"
      :disable-pagination="true"
      mobile-breakpoint=""
      :hide-default-header="true"
      :hide-default-footer="true"
    >
      <template v-slot:no-data="">
        <DataTableEmpty hideButton text="Không có nội dung để hiện thị"></DataTableEmpty>
      </template>
      <template v-slot:top="">
        <div class="d-flex pa-3 align-center">
          <span class="text-body-2"> Total: {{ tableData.length }} </span>
          <div class="flex-fill"></div>

          <v-btn icon v-if="$vuetify.breakpoint.mobile" @click="filterDialogOpen = true">
            <v-icon>mdi-filter</v-icon>
          </v-btn>
          <div v-if="tableData.length">
            <v-btn
              :icon="$vuetify.breakpoint.mobile"
              :loading="exporting"
              text
              @click="onClickExport"
            >
              <span v-if="!$vuetify.breakpoint.mobile"> Tải xuống </span>
              <v-icon :right="!$vuetify.breakpoint.mobile"> mdi-download </v-icon>
            </v-btn>
          </div>
        </div>
      </template>
      <template v-slot:header="{ props, on }">
        <thead class="v-data-table-header">
          <tr>
            <th rowspan="2" class="big-vert-cell column-index">STT</th>
            <th rowspan="2" class="big-vert-cell column-name">Họ và tên</th>
            <th rowspan="2" class="big-vert-cell column-status">Trạng thái</th>
            <th rowspan="2" class="big-vert-cell column-group">Nhóm lớp</th>
            <th
              v-for="s in markSheetData.semester_configs.filter(
                i => (i.semester_course_configs || {}).length
              )"
              :key="s._id"
              :colspan="s.semester_course_configs.length + 2"
              class="text-center amber black--text"
              :style="{ width: (s.semester_course_configs.length + 2) * 120 + 'px' }"
            >
              {{ s.title }}
            </th>
            <th rowspan="2" class="big-vert-cell text-center column-tk amber black--text">
              TB TK TC
            </th>
            <th rowspan="2" class="big-vert-cell text-center column-rank">Xếp loại</th>
            <th rowspan="2" class="big-vert-cell text-center column-note">Note</th>
          </tr>
          <tr>
            <template
              v-for="s in markSheetData.semester_configs.filter(
                i => (i.semester_course_configs || []).length
              )"
            >
              <th v-for="c in s.semester_course_configs" :key="c._id" class="text-center">
                {{ c.course.title }} ({{ c.multiplier }})
              </th>
              <th :key="s.id" class="text-center grey-cell">TB</th>
              <th :key="s.id" class="text-center grey-cell">Xếp loại</th>
            </template>
          </tr>
        </thead>
      </template>

      <template v-slot:item.rank="{ item }">
        {{ getRankLabel(item.rank) }}
      </template>
      <template v-slot:item.status="{ item }">
        <v-chip v-if="item.status" small label dark :color="getStudentStatusColor(item.status)">{{
          getStudentStatusLabel(item.status)
        }}</v-chip>
      </template>
      <template v-slot:item.note="{ item }">
        <v-btn icon small v-if="!item.row" @click="onClickUpsertRowNote({ student: item.id })">
          <v-icon small> mdi-pencil </v-icon>
        </v-btn>
        <p
          text
          v-else
          class="mb-0 text-truncate row-note"
          @click="onClickUpsertRowNote({ item: item.row })"
        >
          {{ item.row.note }}
        </p>
      </template>

      <!-- <template v-slot:item.actions="{ item }">
        <div class="d-flex">
          <v-btn icon small>
            <v-icon small>mdi-eye</v-icon>
          </v-btn>
          <v-btn icon small @click.stop="onClickDeleteMarkSheet(item)">
            <v-icon small>mdi-delete</v-icon>
          </v-btn>
        </div>
      </template> -->
    </v-data-table>
    <BaseDialog
      v-if="upsertMarkSheetRowDialog.isOpen"
      :isOpen="upsertMarkSheetRowDialog.isOpen"
      :title="upsertMarkSheetRowDialog.title"
      @close="upsertMarkSheetRowDialog.isOpen = false"
      @cancel="upsertMarkSheetRowDialog.onCancel"
      @confirm="upsertMarkSheetRowDialog.callback"
    >
      <v-form lazy ref="form" @submit.prevent="upsertMarkSheetRowDialog.callback()">
        <v-card-text v-if="upsertMarkSheetRowDialog.currentItem" class="pa-4">
          <v-textarea
            autofocus
            rows="10"
            standard
            v-model="upsertMarkSheetRowDialog.currentItem.note"
            label="Nội dung"
            class="mb-3"
            hide-details="auto"
          ></v-textarea></v-card-text
      ></v-form>
    </BaseDialog>
  </div>
</template>
<script>
import BaseDialog from '@/components/base/BaseDialog'
import { saveAs } from 'file-saver'

import { mapActions, mapState } from 'vuex'
import DataTableEmpty from '@/components/DataTableEmpty.vue'
import { groupBy, cloneDeep, sumBy, sum } from 'lodash'
import { round } from 'number-precision'
import {
  getRankFromOverallScore,
  getStudentStatusColor,
  sortListByName,
  getStudentStatusLabel,
  getRankLabel
} from '@/helpers'
import NormalOrDialog from '@/components/NormalOrDialog.vue'
import ContentFilterItems from './ContentFilterItems.vue'
import { isEmpty } from 'lodash'
import XLSX from 'xlsx'
import moment from 'moment'
export default {
  data() {
    return {
      filterDialogOpen: false,
      exporting: false,
      upsertMarkSheetRowDialog: {
        isOpen: false,
        title: '',
        currentItem: null,
        callback: null,
        onCancel: () => {
          this.upsertMarkSheetRowDialog.isOpen = false
        }
      },
      filterPayload: {}
    }
  },
  methods: {
    ...mapActions('marksheet', [
      'fetchOverallMarkSheetContent',
      'fetchMarkSheetRows',
      'updateMarkSheetRow',
      'removeMarkSheetRow',
      'createMarkSheetRow'
    ]),
    ...mapActions('students', ['fetchStudentsNoPaging']),
    onClickDeleteMarkSheet(item) {
      this.$dialog.confirm({
        title: 'Xóa bảng điểm',
        text: ` Bạn có Chắc Chắn xóa bảng điểm và các thông tin liên quan?`,
        okText: 'Có',
        cancelText: 'Hủy',
        done: async () => {
          await this.removeOverallMarkSheet(item.id)
          this.$alert.success('Xóa thành công')
        }
      })
    },
    getStudentStatusLabel,
    getStudentStatusColor,
    getRankLabel,
    onClickExport() {
      if (!(this.tableData || {}).length) {
        this.$alert.error('Không có dữ liệu để xuất Excel')
        return
      }
      const tableElm = document.getElementById('content-table')
      if (!tableElm) {
        return
      }
      this.exporting = true
      try {
        const ws = XLSX.utils.table_to_sheet(tableElm)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, ws)
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
        const blob = new Blob([excelBuffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })
        saveAs(blob, `${this.markSheetData.title}_${moment().format('YYYY-MM-DD[T]HH:mm')}.xlsx`)
      } catch (error) {
        console.error(error)
        this.$alert.error('Có lỗi xả ra')
      } finally {
        this.exporting = false
      }
    },
    onFilterChanged(payload) {
      this.filterPayload = payload
      this.filterDialogOpen = false
    },
    onClickUpsertRowNote({ item, student }) {
      this.upsertMarkSheetRowDialog.isOpen = true
      this.upsertMarkSheetRowDialog.title = item ? 'Sửa ghi chú' : 'Tạo ghi chú'
      this.upsertMarkSheetRowDialog.currentItem = item
        ? cloneDeep(item)
        : { note: '', overall_mark_sheet: this.$route.params['id'], student }
      this.upsertMarkSheetRowDialog.callback = (async () => {
        try {
          if (item) {
            if (!(this.upsertMarkSheetRowDialog.currentItem.note || '').trim()) {
              await this.removeMarkSheetRow(this.upsertMarkSheetRowDialog.currentItem.id)
            } else {
              await this.updateMarkSheetRow(this.upsertMarkSheetRowDialog.currentItem)
            }
            this.$alert.success('Cập nhật thành công')
          } else {
            await this.createMarkSheetRow({
              data: this.upsertMarkSheetRowDialog.currentItem
            })
            this.$alert.success('Tạo thành công')
          }
        } catch (error) {
          console.error(error)
          this.$alert.error('Có lỗi xay ra')
        } finally {
          this.upsertMarkSheetRowDialog.isOpen = false
        }
      }).bind(this)
    }
  },
  computed: {
    ...mapState('marksheet', ['markSheetContents', 'markSheetRows']),
    ...mapState('students', ['studentsNoPaging']),
    markSheetData() {
      return this.markSheetContents.find(i => i.id === this.$route.params['id'])
    },
    relavantStudentGroups() {
      if (!this.markSheetData) {
        return []
      }
      return this.markSheetData.student_groups
    },
    headers() {
      if (!this.markSheetData) {
        return []
      }

      const output = this.markSheetData.semester_configs
        .map(i => i.semester_course_configs)
        .map(k => {
          const output = k.map(j => ({
            align: 'center',
            value: `${j.semester_config.id}_${j.id}`,
            text: j.course.title
          }))
          if (k.length) {
            output.push({
              text: `TB ${k[0].semester_config.title}`,
              value: k[0].semester_config.id,
              align: 'center'
            })
            output.push({
              text: `Xếp loại ${k[0].semester_config.title}`,
              value: `${k[0].semester_config.id}_rank_label`,
              align: 'center'
            })
          }
          return output
        })
        .flat()

      return [
        {
          value: 'index',
          text: 'STT'
        },
        {
          value: 'name',
          text: 'Họ và tên'
        },
        {
          value: 'status',
          text: 'Trạng thái',
          align: 'center'
        },
        {
          value: 'tags',
          text: 'Nhóm lớp'
        },
        ...output,
        { value: 'overall_average', text: 'TB TK TC', align: 'center' },
        { value: 'rank', text: 'Xếp loại', align: 'center' },
        { value: 'note', text: 'Ghi chú' }
      ]
    },
    tableData() {
      if (!this.markSheetData) {
        return []
      }
      const studentList = this.markSheetData.semester_configs
        .map(i => i.semester_course_configs)
        .flat()
        .map(({ _id, content, course, multiplier, semester_config }) =>
          content.map(j => ({
            ...j,
            semester_course_config: _id,
            course: course.id,
            multiplier: multiplier,
            semester_config: semester_config.id
          }))
        )
        .flat()

      const studentListGroupedByStudentId = groupBy(studentList, ({ id }) => id)
      let output = Object.entries(studentListGroupedByStudentId)
        .map(([studentId, courseValueList]) => {
          const matchStudent = this.studentsNoPaging.find(s => s.id === studentId)
          if (!matchStudent) {
            return
          }
          const matchRow = this.markSheetRows.find(i => i.student.id === studentId)
          const courseValueObject = courseValueList.reduce(
            (p, { value = null, semester_course_config, semester_config }) => ({
              ...p,
              [`${semester_config}_${semester_course_config}`]: value
            }),
            {}
          )
          const semesterValueObject = Object.entries(
            groupBy(courseValueList, i => i.semester_config)
          ).reduce((p, [k, v]) => {
            if (v.some(i => i.value === undefined || i.value === null)) {
              return p
            }
            let semester_avg = v.some(i => i.value === undefined || i.value === null)
              ? null
              : sumBy(v, i => i.multiplier * i.value) / sum(v.map(i => i.multiplier))

            if (typeof semester_avg === 'number' && !Number.isNaN(semester_avg)) {
              semester_avg = round(semester_avg, 2)
            } else {
              semester_avg = null
            }

            const semesterRank = getRankFromOverallScore(semester_avg)

            return {
              ...p,
              [k]: semester_avg,
              [`${k}_rank`]: semesterRank,
              [`${k}_rank_label`]: getRankLabel(semesterRank)
            }
          }, {})

          let overall_average = courseValueList.some(i => i.value === undefined || i.value === null)
            ? null
            : sumBy(courseValueList, i => i.multiplier * i.value) /
              sum(courseValueList.map(i => i.multiplier))
          if (typeof overall_average === 'number' && !Number.isNaN(overall_average)) {
            overall_average = round(overall_average, 2)
          } else {
            overall_average = null
          }

          return {
            ...matchStudent,
            overall_average,
            row: matchRow,
            rank: getRankFromOverallScore(overall_average),
            ...courseValueObject,
            ...semesterValueObject
          }
        })
        .filter(Boolean)
      // throw Error('Hello')

      if (!isEmpty(this.filterPayload)) {
        output = output.filter(i => {
          let res = true
          if (this.filterPayload.status && i.status !== this.filterPayload.status) {
            res = false
          }
          if (this.filterPayload.rank) {
            if (
              this.filterPayload.semester &&
              i[`${this.filterPayload.semester}_rank`] !== this.filterPayload.rank
            ) {
              res = false
            } else if (!this.filterPayload.semester && i.rank !== this.filterPayload.rank) {
              res = false
            }
          }
          return res
        })
      }
      output = sortListByName(output)
      return output.map((i, id) => ({ ...i, index: id + 1 }))
    }
  },
  components: {
    ContentFilterItems,
    NormalOrDialog,
    DataTableEmpty,
    BaseDialog
  },
  created() {
    this.fetchOverallMarkSheetContent({ marksheetId: this.$route.params.id })
    this.fetchMarkSheetRows({ marksheetId: this.$route.params.id })
  },
  watch: {
    relavantStudentGroups(v) {
      const groupTexts = v.map(i => i.text)
      const filter = {
        'populate[0]': 'none', // just to disable auto population
        ...Object.fromEntries(groupTexts.map((t, id) => [`_where[_or][${id}][tags_contains]`, t]))
      }
      this.fetchStudentsNoPaging(filter)
    }
  }
}
</script>
<style scoped lang="scss">
@import '~vuetify/src/styles/styles.sass';

::v-deep {
  .v-data-table__wrapper thead th {
    border-left-width: 1px;
    border-left-style: solid;
    border-left-color: #dddddd !important;
  }
  thead tr:nth-child(1) th:first-child {
    border-left-width: 0 !important;
  }
  table td:not(:first-child) {
    border-left: 1px solid #dddddd;
  }
}
.big-hor-cell {
  background-color: orange;
  color: black !important;
}
.big-vert-cell {
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
  &:not(:first-child) {
    border-left: 1px solid #dddddd;
  }
}
.row-note {
  text-transform: unset;
  font-weight: normal;
  cursor: pointer;
  max-width: 120px;
}
.column-name {
  width: 100px;
}
.column-status {
  width: 120px;
}
.column-group {
  width: 100px;
}
.column-tk {
  width: 80px;
}
.column-rank {
  width: 140px;
}
.column-note {
  width: 60px;
}
.column-index {
  width: 60px;
}
::v-deep {
  th,
  td {
    background-color: #fff;
  }
  tr:first-child th {
    position: sticky;
    top: 0;
    z-index: 1;
  }
  tr:nth-child(2) th {
    position: sticky;
    top: 32px;
    z-index: 1;
  }
  .v-data-table__wrapper {
    height: calc(100vh - 290px);
    overflow-x: auto;
    overflow-y: auto;
  }
  table {
    table-layout: fixed;
  }
  th:first-child,
  td:first-child {
    left: -1px;
  }
  th:nth-child(2),
  td:nth-child(2) {
    left: 58px;
  }
  tr:first-child {
    th:nth-child(-n + 2) {
      position: sticky;
      z-index: 2;
    }
  }
  td:nth-child(-n + 2) {
    position: sticky;
    z-index: 1;
  }
}
.grey-cell {
  background-color: #d8d8d8;
}
@media #{map-get($display-breakpoints, 'sm-and-up')} {
  .row-note {
    max-width: 200px;
  }
  .column-name {
    width: 200px;
  }
}
</style>
